import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { incidentNoteResponseSchema } from "features/CenterContent/RoleContent/ISirk/types";
import * as z from "zod";
import { format } from "date-fns";
import { mutationFnPOST } from "api/tanStackQuery/helpers";
import type { CreateIncidentLogMessageSchema } from "features/CenterContent/RoleContent/ISirk/types";

export const useISirkView = (selectedDate: string) => {
  const formatedDate = format(selectedDate, "yyyy-MM-dd");

  const { data, status } = useQuery({
    queryKey: ["iSirk", formatedDate],
    queryFn: async ({ signal }) =>
      axiosClient
        .get<z.infer<typeof incidentNoteResponseSchema>>(
          `${getBackendUrl()}/alternative-transport/incident-notes?from=${formatedDate}`,
          {
            signal,
          },
        )
        .then((res) => incidentNoteResponseSchema.parse(res.data)),
  });
  return { data, status };
};

export const useISirklogMessagePublish = () => {
  const queryClient = useQueryClient();
  const {
    mutate: postIncidentLog,
    status: mutationStatus,
    reset: resetMutation,
  } = useMutation({
    mutationFn: (data: CreateIncidentLogMessageSchema) =>
      mutationFnPOST<void, CreateIncidentLogMessageSchema>(
        `${getBackendUrl()}/alternative-transport/incident-logs`,
        data,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["iSirkLogs"] });
      void queryClient.invalidateQueries({ queryKey: ["iSirk"] });
    },
  });
  return { postIncidentLog, mutationStatus, resetMutation };
};
